export const STORY_TYPES_ARRAY = ['press-release', 'news', 'financial']
